/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { productControllerCreate } from '../fn/product/product-controller-create';
import { ProductControllerCreate$Params } from '../fn/product/product-controller-create';
import { productControllerDelete } from '../fn/product/product-controller-delete';
import { ProductControllerDelete$Params } from '../fn/product/product-controller-delete';
import { productControllerExpose } from '../fn/product/product-controller-expose';
import { ProductControllerExpose$Params } from '../fn/product/product-controller-expose';
import { productControllerFindById } from '../fn/product/product-controller-find-by-id';
import { ProductControllerFindById$Params } from '../fn/product/product-controller-find-by-id';
import { productControllerSearch } from '../fn/product/product-controller-search';
import { ProductControllerSearch$Params } from '../fn/product/product-controller-search';
import { productControllerUpdate } from '../fn/product/product-controller-update';
import { ProductControllerUpdate$Params } from '../fn/product/product-controller-update';
import { ProductDto } from '../models/product-dto';

@Injectable({ providedIn: 'root' })
export class ProductService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productControllerSearch()` */
  static readonly ProductControllerSearchPath = '/api/product';

  /**
   * Search products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerSearch$Response(params: ProductControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return productControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * Search products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerSearch(params: ProductControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.productControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `productControllerCreate()` */
  static readonly ProductControllerCreatePath = '/api/product';

  /**
   * Create product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerCreate$Response(params: ProductControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    return productControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerCreate(params: ProductControllerCreate$Params, context?: HttpContext): Observable<ProductDto> {
    return this.productControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

  /** Path part for operation `productControllerFindById()` */
  static readonly ProductControllerFindByIdPath = '/api/product/{id}';

  /**
   * Get product by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerFindById$Response(params: ProductControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    return productControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get product by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerFindById(params: ProductControllerFindById$Params, context?: HttpContext): Observable<ProductDto> {
    return this.productControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

  /** Path part for operation `productControllerDelete()` */
  static readonly ProductControllerDeletePath = '/api/product/{id}';

  /**
   * Delete product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerDelete$Response(params: ProductControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return productControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerDelete(params: ProductControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    return this.productControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `productControllerUpdate()` */
  static readonly ProductControllerUpdatePath = '/api/product/{id}';

  /**
   * Update product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerUpdate$Response(params: ProductControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    return productControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerUpdate(params: ProductControllerUpdate$Params, context?: HttpContext): Observable<ProductDto> {
    return this.productControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

  /** Path part for operation `productControllerExpose()` */
  static readonly ProductControllerExposePath = '/api/product/expose/{id}';

  /**
   * toggle product expose.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerExpose()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerExpose$Response(params: ProductControllerExpose$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    return productControllerExpose(this.http, this.rootUrl, params, context);
  }

  /**
   * toggle product expose.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerExpose$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerExpose(params: ProductControllerExpose$Params, context?: HttpContext): Observable<ProductDto> {
    return this.productControllerExpose$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

}
